// removed by extract-text-webpack-plugin
module.exports = {"title":"src-components-home-home-culture-home-culture-title----home-culture-title-module---title---kl51H","titleDesktop":"src-components-home-home-culture-home-culture-title----home-culture-title-module---titleDesktop----PI_K","titleMobile":"src-components-home-home-culture-home-culture-title----home-culture-title-module---titleMobile---lNPTW"};


//////////////////
// WEBPACK FOOTER
// ./src/components/home/home-culture/home-culture-title/home-culture-title.module.css
// module id = 491
// module chunks = 35783957827783